<template>
  <div>
    <b-modal
      id="modalObjectif"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
      :title="titleModal"
    >
      <template #default>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row mt-n1">
            <div class="col-12">
              <div class="form-group">
                <label for="nom"
                  >Nom de l'objectif <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{ 'is-invalid': form.errors.has('nom') }"
                  id="nom"
                  v-model="form.nom"
                  type="text"
                  placeholder="Nom de l'objectif"
                  maxlength="100"
                  required
                />
                <has-error :form="form" field="nom"></has-error>
              </div>
            </div>

            <div class="col-md-12 col-lg-6">
              <div class="form-group">
                <label for="date_attribution"
                  >Date d'attribution <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date_attribution"
                  name="date_attribution"
                  placeholder="Date d'attribution"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date_attribution'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date_attribution"></has-error>
              </div>
            </div>

            <div class="col-md-12 col-lg-6">
              <div class="form-group">
                <label for="date_realisation_prevu"
                  >Date de réalisation prévisionnelle
                  <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date_realisation_prevu"
                  name="date_realisation_prevu"
                  placeholder="Date de réalisation prévisionnelle"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date_realisation_prevu'),
                  }"
                  type="hidden"
                />
                <has-error
                  :form="form"
                  field="date_realisation_prevu"
                ></has-error>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalObjectif')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Enregistrer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/rh/employe-objectif';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import CONST from '@/constants/rh/employe';
export default {
  data() {
    return {
      CONST,
      titleModal: 'Ajout de nouvel objectif',

      form: new Form({
        employe: '',
        nom: '',
        date_attribution: this.$options.filters.formatDate(
          new Date(),
          'DD/MM/YYYY'
        ),
        date_realisation_prevu: '',
        objectifable_type: this.objectifableType,
        objectifable_uuid: this.objectifableUuid,
      }),
    };
  },
  components: {
    DatePicker,
  },

  methods: {
    create() {
      this.form.clear();
      this.form.reset();
      this.$bvModal.show('modalObjectif');
    },
    async edit(id) {
      this.form.reset();
      this.form.clear();

      await window.axios
        .get(URL.OBJECTIF + '/' + id, { params: { edit: true } })
        .then((resp) => {
          Object.assign(this.form, resp.data.objectif);
        })
        .catch();

      await this.$bvModal.show('modalObjectif');
    },
    submit() {
      this.$bvModal.hide('modalObjectif');
      this.form.employe = this.currentEmploye.uuid;

      if (this.form.id) {
        this.form
          .put(URL.OBJECTIF + '/' + this.form.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.form.reset();
            this.form.clear();
            this.$emit('successSavedObjectif');
          })
          .catch(() => {
            this.$bvModal.show('modalObjectif');
          });
      } else {
        this.form
          .post(URL.OBJECTIF)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.form.reset();
            //this.$emit('onCreated', resp.data.objectif);
            this.$router
              .push({
                name: this.showUrl + '-show',
                params: {
                  employeId: this.currentEmploye.id,
                  prov: this.prov,
                  objectifId: resp.data.objectif.id,
                },
              })
              .catch();
          })
          .catch(() => {
            this.$bvModal.show('modalObjectif');
          });
      }
    },
  },

  props: [
    'currentEmploye',
    'prov',
    'objectifableUuid',
    'objectifableType',
    'showUrl',
  ],
};
</script>

<style scoped lang="scss"></style>
